import React from "react";
import {withStyles} from "@material-ui/core/styles";
import PropTypes from "prop-types";
import {getBrowseLanguageCode} from "../../../components/util";
import GraphView from "../GraphView";

export const GRAPH_EXPLORER_SETTINGS = [
]

class GraphExplorer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
    }

    render() {
        let {browseLanguage, dataExporter, aliasesMap, aliasesToIRIMap, workspace, topMenuAction, settings, configurations, ontology, location, sparqlData, visualisationConfigurationForSPARQL} = this.props;
        return <div style={{width: '100%', height: '100%', position :'relative'}}>
            <GraphView
                containerId={"graphExplorer"}
                embedded={true}
                workspace={workspace}
                settings={settings}
                aliasesMap={aliasesMap}
                aliasesToIRIMap={aliasesToIRIMap}
                languageCode={getBrowseLanguageCode(browseLanguage)}
                configurations={configurations}
                ontology={ontology}
                location={location}
                minimized={true}
                sparqlData={sparqlData}
                onClose={() => {
                }}
                open={true}
                hideButton={true}
                dataExporter={dataExporter}
                visualisationConfigurationForSPARQL={visualisationConfigurationForSPARQL}
                topMenuAction={topMenuAction}
            />
        </div>
    }

}

GraphExplorer.propTypes = {
    diagramSettings: PropTypes.any,
    sparqlData: PropTypes.any,
};

export default withStyles({}, {withTheme: true})(GraphExplorer);
